import { configureStore } from '@reduxjs/toolkit';
import contentReducer from './slices/contentSlice';
import deviceReducer from './slices/deviceSlice';
import statusReducer from './slices/statusSlice';
import scenarioReducer from './slices/scenarioSlice';
import userReducer from './slices/userSlice';

export default configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'scenario/setOnCompletion',
          'device/setVideoinputDevices',
          'device/setAudioinputDevices',
          'device/setAudiooutputDevices',
        ],
        // Ignore these paths in the state
        ignoredPaths: ['scenario.onCompletion'],
      },
    }),
  reducer: {
    content: contentReducer,
    device: deviceReducer,
    scenario: scenarioReducer,
    status: statusReducer,
    user: userReducer,
  },
});
